<template>
  <div id="inspire">
      <v-container fluid>
          <v-carousel
            delimiter-icon="fas fa-stop-circle"
            prev-icon="fas fa-angle-left"
            next-icon="fas fa-angle-right"
          >
            <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
            >
            </v-carousel-item>
          </v-carousel>
          <v-content>
            <div class="text-center">
                <h2 class="display-1 text-uppercase" style="padding-bottom:15px">Ketti People Culture <br> கேத்தி மக்களின் கலாச்சாரம்</h2>
            </div>
            <div>
                <p class="text-justify headline">{{culture1}}</p>
                <p class="text-justify subheading">{{culture2}}</p>
            </div>
              <div class="text-center">
                  <h2 class="display-1 text-uppercase" style="padding-bottom:15px">Accessibility <br>அணுகல்  </h2>
              </div>
            <div>
                <p class="text-justify subheading">{{rail}}</p>
                <p class="text-justify subheading">{{transport}}</p>
            </div>
            <div class="text-center">
                  <h2 class="display-1 text-uppercase" style="padding-bottom:15px">Toursim <br>சுற்றுலா  </h2>
              </div>
            <div>
                <p class="text-justify subheading">{{tour}}</p>
            </div>
            <div class="text-center">
                  <h2 class="display-1 text-uppercase" style="padding-bottom:15px">Educational Institutions <br>கல்வி நிறுவனங்கள்  </h2>
              </div>
            <div>
                <p class="text-justify subheading">{{Education}}</p>
            </div>
          </v-content>
      </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        src: 'https://badaga.files.wordpress.com/2011/12/badagas-with-family-1914.jpg',
      },
      {
        src: 'https://www.indianetzone.com/photos_gallery/42/Badagas.jpg',
      },
      {
        src: 'https://static.toiimg.com/imagenext/toiblogs/photo/blogs/wp-content/uploads/2018/01/1-10.jpg',
      },
      {
        src: 'https://lh3.googleusercontent.com/-AqFwa1PB6SE/WChFzIZInFI/AAAAAAAAAVY/B4I3GUkZuHYefB9OFJbi1Bt1Xby4ez8VQCLIB/w1080-h608-p-k-no-v0/',
      },
      {
        src: 'https://th.thgim.com/migration_catalog/article15491394.ece/alternates/FREE_435/OT18_BADAGA',
      },
    ],
    culture1: 'Badagas, one of the indigenous people of Nilgiris, are mostly Hindus and their festivals revolve around Shiva, Mariamma and Hethai Amman. Hethe Habba is one of the most famous festivals in the Badaga community, which happens on the first Monday after the full moon day.',
    culture2: 'Thundu (a white piece of cloth) and Seeley forms an integral part of the attire of the Badugu women.Badugas marry within their community and follow their own marriage traditions. Their important festival is Devva Habba. Devva Habba provides significant insights into the origin of Badugas. They have certain rules and regulations to be followed in implementing their cultural rituals from the birth of a child and follows through functions like puberty, marriage, naming ceremony, seventh-month pregnancy, housewarming, and finally in death.The people present here are mostly Badaga and Tamils with certain immigrants from other parts of Tamil Nadu, Kerala, Karnataka and Sri Lankan Tamils. The chief language spoken here is Badaga and Tamil, although many people understand English, Malayalam and Kannada. Religion practised here is mostly Hinduism. However, strong influences remain of the Christian missionaries who lived here during the early 1900s.',
    rail: 'Ketti is accessible by rail or road. The mountain train NMR (recently declared as a national heritage site by UNESCO and which provides a connection to the Chennai - Coimbatore - Mettupalayam Niligiri Express), can be boarded from the Mettupalayam station (at the foothills of the Nilgiris) to the Ketti railway station.',
    transport: 'The Gorvenment and private transport facility are avaliable with mean time only.',
    tour: 'The valley is the last major valley en route to Ooty along the Ooty-Coonoor highway. However, due to the extensive development of the valley in the recent years, the fauna present here has dwindled to a select few.',
    Education: 'The Laidlaw Memorial School and Junior College, Ketti,The CSI College of Engineering, Safa valley road,ketti.,etc.,',
  }),
};
</script>

<style>

</style>
